import "./Anonymity.css";
import "../../App.css";
import "../components/BottomNav.css";
import logo from "../../assets/fishtagged-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Hamburger from '../components/Hamburger';
import { snapshotCurrentReport, upsertReport } from '../../reportStorage';

const Anonymity = ({ user, setUser }) => {
  const navigate = useNavigate();
  const accountName = user.isLoggedIn ? user.name : "Not logged in";
  const accountType = user.isLoggedIn ? user.accountType : "-";

  const [isAnonymous, setIsAnonymous] = useState(() => {
    const saved = sessionStorage.getItem("anonymityData");
    if (saved) {
      try { return JSON.parse(saved).isAnonymous ?? true; } catch {}
    }
    return true;
  });

  useEffect(() => {
    console.log("User info in Anonymity:", accountName, accountType);
  }, [accountName, accountType]);

  useEffect(() => {
    if (!user.isLoggedIn) {
      setIsAnonymous(true);
      sessionStorage.setItem("anonymityData", JSON.stringify({
        isAnonymous: true,
        observationType: "Anonymous",
      }));
    }
  }, [user]);

  const handleNext = () => {
    const anonymityPayload = {
      isAnonymous,
      observationType: isAnonymous ? "Anonymous" : accountName,
    };

    sessionStorage.setItem("anonymityData", JSON.stringify(anonymityPayload));


    const activeId = sessionStorage.getItem("activeReportId") || null;
    const report = snapshotCurrentReport(activeId, []);
    upsertReport(report);

    if (!activeId) {
      sessionStorage.setItem("activeReportId", report.id);
    }

    navigate("/uploadFiles");
  };

  return (
    <>
      <div className="bg-image" />
      <div className="top-row">
        <div className="logo">
          <img src={logo} alt="FishTagged Logo" />
        </div>
        <div className="top-hamburger">
          <Hamburger user={user} />
        </div>
      </div>
      <div className="a-viewport">
        <div className="a-content">
          <div className="card-wrapper">
            <div className="a-card">
              <p className="a-entry">New entry (1 out of 5)</p>
              <h1 className="a-title">Anonymity</h1>
              <p className="a-subtitle">
                Do you want to submit this entry using your account?
              </p>
              <div className="a-option-card">
                <label className="a-option">
                  <input
                    type="radio"
                    name="anon"
                    checked={isAnonymous}
                    onChange={() => setIsAnonymous(true)}
                  />
                  <span>No, submit anonymously</span>
                </label>
				<p className="a-account-note">
                   Note that anonymous accounts are not eligible to participate in rewards.
                </p>
                <div className="a-divider" />
                <label
                  className={`a-option ${!user.isLoggedIn ? "a-disabled-option" : ""}`}
                >
                  <input
                    type="radio"
                    name="anon"
                    checked={!isAnonymous}
                    onChange={() => setIsAnonymous(false)}
                    disabled={!user.isLoggedIn}
                  />
                  <div>
                    <p className="a-account-name">Submit as: {accountName}</p>
                  </div>
                </label>
			    {
				  !user.isLoggedIn &&
				  <p className="a-account-note">This option is disabled because you are not logged in. Click <u className="you-can-click-here" onClick={() => navigate("/")}>here</u> to return home and log in.</p>
			    }
              </div>
            </div>
            <div className="bottom-nav">
              <FontAwesomeIcon icon={faAngleLeft} className="arrow" onClick={() => navigate("/")} />
              <FontAwesomeIcon icon={faAngleRight} className="arrow" onClick={handleNext} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Anonymity;
